import React, {Dispatch, SetStateAction} from 'react';
import {Dimensions} from 'components/customer/JobDashboard/columns/Dimensions';
import {Product} from 'components/customer/Product/entity/Product';

interface ProductQuantityProps {
    row: Product;
    setShowForm: Dispatch<SetStateAction<boolean>>;
}

export const MobileDimensionEditor = ({
    row,
    setShowForm,
}: ProductQuantityProps) => {
    return (
        <Dimensions
            productDetails={row}
            hideDimensions={true}
            setShowForm={setShowForm}
        />
    );
};
